import { DisablerActionTypes } from './actionTypes';
import type * as Actions from './actions';

import type { DisablerAction, DisablerEvent, ESN } from '@cobliteam/common-types';

export const loadDevicesStatusRequest = (): Actions.LoadDevicesStatusRequest => ({
  type: DisablerActionTypes.LOAD_DEVICES_STATUS_REQUEST,
});

export const loadDevicesStatusFailed = (): Actions.LoadDevicesStatusFailed => ({
  type: DisablerActionTypes.LOAD_DEVICES_STATUS_FAILED,
});

export const loadDevicesStatusSucceeded = (events: DisablerEvent[]): Actions.LoadDevicesStatusSucceeded => ({
  type: DisablerActionTypes.LOAD_DEVICES_STATUS_SUCCEEDED,
  payload: events,
});

export const askDisablerActionRequest = (deviceId: ESN, requestedAction: DisablerAction): Actions.AskDisablerActionRequest => ({
  type: DisablerActionTypes.ASK_DISABLER_ACTION_REQUEST,
  payload: { deviceId, requestedAction },
});

export const askDisablerActionFailed = (): Actions.AskDisablerActionFailed => ({
  type: DisablerActionTypes.ASK_DISABLER_ACTION_FAILED,
});

export const askDisablerActionSucceeded = (deviceId: ESN, requestedAction: DisablerAction): Actions.AskDisablerActionSucceeded => ({
  type: DisablerActionTypes.ASK_DISABLER_ACTION_SUCCEEDED,
  payload: { deviceId, requestedAction },
});

export const putDisablerCompleted = (deviceId: ESN): Actions.PutDisablerCompleted => ({
  type: DisablerActionTypes.PUT_DISABLER_COMPLETED,
  payload: { deviceId },
});
